import React, { Component } from "react";
import "../../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import ViewTopBar from "../common_components/viewChanger";
import BottomBar from "../common_components/bottom_bar.component";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  image: {
    height: "10%",
    width: "100%",
    marginTop: "-6%",
  },
  text_title: {
    textAlign: "left",
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "600",
    "@media (min-width:200px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:600px)": {
      fontSize: "2rem",
    },
    "@media (min-width:960px)": {
      fontSize: "3rem",
    },
  },
  text_grid: {
    width: 930,
    marginLeft: 150,
    marginRight: 150,
    fontSize: "1.25rem",
    "@media (min-width:200px)": {
      marginLeft: 50,
      marginRight: 50,
      width: 450,
    },
    "@media (min-width:600px)": {
      marginLeft: 80,
      marginRight: 80,
      width: 450,
    },
    "@media only screen and (max-width: 960px) and (min-width:601px)": {
      marginLeft: 100,
      marginRight: 100,
      width: 400,
    },
    "@media only screen and (max-width: 1600px) and (min-width: 1265px)": {
      width: 440,
    },
    "@media only screen and (max-width: 1760px) and (min-width: 1600px)": {
      width: 670,
    },
    "@media only screen and (max-width: 1960px) and (min-width: 1760px)": {
      width: 800,
    },
  },
  text: {
    color: "black",
    fontFamily: "Open Sans",
    fontWeight: "300",
    fontSize: "1.25rem",
    "@media (min-width:200px)": {
      fontSize: "0.9rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1rem",
    },
    "@media (min-width:960px)": {
      fontSize: "1.1rem",
    },
  },
});

class About extends Component {
  componentDidMount() {
    document.title = "About | CanaWho";
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <ViewTopBar />
        <Grid
          container
          direction="column"
          justify="center"
          alignContent="center"
        >
          <img
            alt=""
            class={classes.image}
            src={
              "https://canawho-bucket.s3.ca-central-1.amazonaws.com/1583260332366_banner.png"
            }
          />
          <Container maxWidth="md">
            <h1 class={classes.text_title}>
              <u>About CanaWho</u>
            </h1>
            <Typography variant="h5" class={classes.text}>
              CanaWho™ was founded by Toronto native Pedro Correia who began as
              a medical cannabis patient, to a cannabis connoisseur, and now an
              entrepreneur. Mr. Correia created CanaWho™ with the objective of
              uniting the cannabis space by encouraging people to learn,
              explore, and communicate together.
              <br />
              <br />
            </Typography>
            <Typography
              variant="h5"
              class={classes.text}
              style={{ textAlign: "center" }}
            >
              <b>Our Mission</b>
              <br />
              <i>
                Is to Encourage your Relationship with Cannabis, Igniting the
                Confidence within You.
              </i>
              <br />
              <br />
              <b>Our Values</b>
              <br />
              <i>
                Comprise of Community, Experience, Passion, Support, and
                Innovation.
              </i>
            </Typography>
            <Typography variant="h5" class={classes.text}>
              <br />
              <br />
              Our purpose is to make your cannabis journey supportive and
              enjoyable so that you may better understand cannabis at your pace,
              in a fun and inclusive way. Likewise, CanaWho™ provides the
              information needed in one place to help you make safe cannabis
              decisions. Overall, CanaWho™ is dedicated to creating a confident
              cannabis community that communicates and grows together.
              <br />
              <br />
              CanaWho™ has a variety of functions that are here to help guide
              you through your cannabis journey; whether you are currently
              consuming or simply curious about cannabis. The CanaWho™ Community
              embraces experiences and conversation; we believe that everyone
              can learn from each other if we all share our own experiences.
              Wanda is CanaWho™ Virtual Cannabis Specialist who is here to break
              the ice in terms of removing the anxieties and pressures you may
              feel when purchasing cannabis; what do I ask for? What brand is
              best for me? What do I say? These are all common questions that
              you may be thinking to yourself and Wanda is here to help. Lastly,
              the Explore page allows you to confidently search through cannabis
              as it exclusively showcases legal Canadian cannabis products,
              retail and clinic locations near you.
              <br />
              <br />
              CanaWho™ is a community centric platform focused on igniting
              confidence in each cannabis experience by providing a space to
              come together and encourage respectful, supportive, and inclusive
              conversation amongst us all.
              <br />
              <br />
            </Typography>
            <Typography
              variant="h5"
              class={classes.text}
              style={{ textAlign: "center" }}
            >
              <b>Our Vision</b>
              <br />
              <i>
                Is to be recognized as the community centric platform that
                unites cannabis worldwide.
              </i>
              <br />
              <br />
              Express Yourself, Enjoy Yourself, and Let’s Grow this Community
              Together!
            </Typography>
            <h1 class={classes.text_title}>
              <u>Meet Pedro</u>
            </h1>
            <Typography variant="h5" class={classes.text}>
              Pedro Correia is the founder of CanaWho™ and his cannabis journey
              started in 2012. Through the pursuit of his professional soccer
              career he was faced with a life changing event during his time at
              the Sigma FC Academy where he suffered a severe head injury. Pedro
              began his recovery with a series of medical professionals who
              provided various solutions ranging from pain killers, anti-
              inflammatories, to antidepressants.
              <br />
              <br />
              However, Pedro did not feel comfortable taking these medications
              consistently because he did not experience the relief he was
              looking for. Also, he was aware of the potential adverse effects
              associated with the long term consumption of these medications.
              Likewise, Pedro sought out a long-term solution that would
              compliment his lifestyle and his value for plant-based
              alternatives.
              <br />
              <br />
              Pedro began his pursuit to find new alternatives and in doing so,
              he came across an article that discussed how the National Football
              League (NFL) was exploring the potential benefits of cannabis on
              concussion-related injuries. From this finding, his perspective on
              cannabis was changed and allowed him to accept cannabis into his
              life as a suitable solution for his condition.
              <br />
              <br />
              As Pedro continued his research to further understand cannabis, he
              realized that he was not solely learning for the betterment of his
              health but rather his passion for cannabis. Through Pedro’s
              experiences he recognized the strong essence of community that
              existed within the cannabis space. Likewise, the experiences
              shared amongst one another were crucial to Pedro’s growth as he
              found value in listening to the stories of others. He aspired to
              make cannabis respected in society by normalizing its consumption
              and conversation. With that said, he believed that the cannabis
              community had the potential to remove the stigma associated with
              cannabis by coming together and providing a space that encourages
              respectful, supportive, and inclusive conversation.
              <br />
              <br />
            </Typography>
            <Typography
              variant="h5"
              class={classes.text}
              style={{ textAlign: "center", marginBottom: "120px" }}
            >
              Thus, yesterday’s experiences created today’s CanaWho™.
            </Typography>
          </Container>
        </Grid>
        <Grid style={{ marginTop: -25 }}>
          <BottomBar />
        </Grid>
      </div>
    );
  }
}

About.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(About);
